import PropTypes from "prop-types";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { API_ROOT } from "../../configs/env-vars";
import { Link } from "react-router-dom";
import ModalVideo from "react-modal-video";
import imageData from "../../data/image-slider/location-slider.json";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import BranchHome from "../../pages/home/BranchHome";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import AnnouncementSingle from "./AnnouncementSingle";
import Swiper from "react-id-swiper";
import Nav from "react-bootstrap/Nav";
import { useSelector } from "react-redux";
import SectionTitleSeven from "../section-title/SectionTitleSeven";

const AnnouncementsContainer = ({ spaceBottomClass }) => {
  const [tabKey, setTabKey] = useState("current");
  const curr_location = useSelector((state) => state.locationsData.location);
  const branch_id = curr_location.id;

  const [pastAnnouncementList, setPastAnnouncementList] = useState([]);
  const [currentAnnouncementList, setCurrentAnnouncementList] = useState([]);

  useEffect(async () => {
    const result = await axios(
      `${API_ROOT}/branches/website-announcements/shown/` + branch_id
    );
    let current =
      (result.data.results &&
        result.data.results["current"] &&
        result.data.results["current"].length > 0) ||
      (result.data.results &&
        result.data.results["past"] &&
        result.data.results["past"].length > 0)
        ? result.data.results["current"]
        : [
            /*{
              title: "Zebra Robotics buys out N.A.S.A for $19.58",
              description:
                "Just kidding! There are no annoucements up yet. But check again soon! We're up to some really cool stuff!",
              img:
                process.env.PUBLIC_URL +
                "/assets/zebra_images/graphics/spaceProgram.png",
            },*/
          ];
    setPastAnnouncementList(result.data.results["past"]);
    setCurrentAnnouncementList(current);
  }, []);

  const params = {
    effect: "fade",
    speed: 1000,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    watchSlidesVisibility: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    renderPrevButton: () => (
      <button className="swiper-button-prev ht-swiper-button-nav">
        <i className="pe-7s-angle-left" />
      </button>
    ),
    renderNextButton: () => (
      <button className="swiper-button-next ht-swiper-button-nav">
        <i className="pe-7s-angle-right" />
      </button>
    ),
  };
  return (
    ((currentAnnouncementList && currentAnnouncementList.length > 0) ||
      (pastAnnouncementList && pastAnnouncementList.length > 0)) && (
      <>
        <div className={spaceBottomClass ? spaceBottomClass : ""}>
          <SectionTitleSeven
            titleText="Meet the Owner(s)"
            positionClass="text-center"
            spaceClass="mb-50"
            borderClass="no-border"
          />
          <div
            className="container announcement-slider-area mb-55"
            style={{
              backgroundImage:
                "url('/assets/zebra_images/graphics/AnnouncementsBanner.png')",
            }}
          >
            <div className="">
              <div className="single-active nav-style-1">
                <Swiper {...params}>
                  {[
                    ...currentAnnouncementList,
                    ...pastAnnouncementList,
                  ].map((single, key) => {
                    return (
                      (
                        <span>
                          <AnnouncementSingle
                            data={single}
                            key={key}
                            sliderClass="swiper-slide"
                          />
                        </span>
                      )
                    );
                  })}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  );
};
AnnouncementsContainer.propTypes = {
  data: PropTypes.object,
};

export default AnnouncementsContainer;
